export default {
	trendingTracks: '/trending-tracks',
	trendingArtists: '/trending-artists',
	timeseries: '/total-streams-and-listeners',
	topTracks: '/top-tracks',
	contexts: '/contexts',
	topArtists: '/top-artists',
};
